import { createTeacher, getTeacherRegistrationStatus } from '../../../modules/teacher/api';
import { CreateTeacherPayload, Teacher, TeacherRegistrationStatus } from '../../../modules/teacher/types';

export const createTeacherUseCase = async (payload: CreateTeacherPayload): Promise<Teacher> => {
  return createTeacher(payload);
};

export const getTeacherRegistrationStatusUseCase = async (inviteToken: string): Promise<TeacherRegistrationStatus> => {
  return getTeacherRegistrationStatus(inviteToken);
};